import { BALLOON } from '@makemydeal/dr-platform-types';
import { actionCreators } from '@makemydeal/dr-offer-redux';
import { CALC_ENDPOINTS } from '../constants';
import * as baseDealSelectors from '../selectors/BaseDealSelectors';
import { setCalcEngineTransitionState } from './baseDealActionCreators';

export const BALLOON_FALLBACK_HIGHLIGHT = 'BALLOON_FALLBACK_HIGHLIGHT';
export const BALLOON_FALLBACK_HIGHLIGHT_CLEAR = 'BALLOON_FALLBACK_HIGHLIGHT_CLEAR';
export const BALLOON_FALLBACK_DEFAULT_AMOUNT = 1;

export const setBalloonFallbackHighlight = (highlighted: boolean) => ({
    type: highlighted ? BALLOON_FALLBACK_HIGHLIGHT : BALLOON_FALLBACK_HIGHLIGHT_CLEAR
});

/**
 * Thunk: Triggered when PQ fails to return a payment for Balloon after switching from Finance.
 * Makes a subsequent UPQ call using the saved Finance term, buy rate, sell rate, and balloon amount = $1.
 */
export const triggerBalloonFallbackToUPQ = () => {
    return (dispatch: any, getState: any) => {
        const state = getState();
        const calcEngineTransitionState = baseDealSelectors.getCalcEngineTransitionState(state);
        const financeData = calcEngineTransitionState?.balloonFallbackFinanceData;

        if (!financeData) {
            return;
        }

        // Clear the saved finance data immediately to prevent re-triggering
        // if the subsequent UPQ call also fails. Set balloonFallbackPending so
        // the middleware can fire the highlight after a successful UPQ response.
        dispatch(
            setCalcEngineTransitionState({
                ...calcEngineTransitionState,
                balloonFallbackFinanceData: undefined,
                balloonFallbackPending: true
            })
        );

        const { buyRate, sellRate, balloonAmount = BALLOON_FALLBACK_DEFAULT_AMOUNT } = financeData;

        // Set balloon amount from saved data (defaults to $1 when switching from Finance to Balloon)
        dispatch(actionCreators.updateBalloonPaymentAmount(balloonAmount, false));

        // Set sell rate override from previous Finance quote
        if (sellRate != null) {
            dispatch(actionCreators.updateSellRateForSelectedTermUPQ(sellRate));
        }

        // Set buy rate override from previous Finance quote
        if (buyRate != null) {
            dispatch(actionCreators.updateBuyRateForSelectedTermUPQ(buyRate));
        }

        // Switch endpoint to UPQ for Balloon and trigger payment call
        dispatch(actionCreators.updateCurrentCalculationEndpoint(CALC_ENDPOINTS.userProgramQuotes, BALLOON, { withPayment: true }));
    };
};
